import routes from 'app.routes';

export const tabParams = {
  accountSettings: {
    myAccount: 'my-account',
    userAdministration: 'user-administration',
    helpCenter: 'help-center',
    branch: 'branch',
  },
  textDocuments: {
    other: 'Other',
  },
};

export const UNAVAILABLE_SIDEBAR_ROUTES = [
  routes.v2.activeDirectory,
  routes.v2.authRedirect,
  routes.v2.login,
  routes.v2.questionnaire,
  routes.presentation.toString(),
  routes.acceptInvite().toString(),
  routes.booking().toString(),
  routes.interview().toString(),
];

export const UNAVAILABLE_MOBILE_NAVBAR_ROUTES = [routes.v2.order.newOrder];
